import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import moment from 'moment'
import i18n from 'i18next'
import { v4 as uuidv4 } from 'uuid'

import Button from '../../../../../UniformComponents/Button'
import Select from '../../../../form/Select'
import Date from '../../../../form/Date'
import Panel from '../../../../../UniformComponents/Panel'
import PanelHeader from '../../../../../UniformComponents/PanelHeader'
import InfoAccordion from '../../../../InfoAccordion'
import QuestionOption from './QuestionOption'
import Applied from './Applied'

import Rule from './model/Rule'
import RuleLogic from './model/RuleLogic'
import RuleGroup from './model/RuleGroup'
import Badge from '../../../../../UniformComponents/Badge'

@observer
class FilterPanel extends Component {
    constructor(props) {
        super(props)

        const { ruleGroup, filterKey } = props

        this.state = {
            showBody: false,
            ruleGroup: RuleGroup.clone(ruleGroup[filterKey]),
        }

        console.log('filterPanel ruleGroup', this.state.ruleGroup)
    }

    save = () => {
        const { filterKey, reportStore, onSave } = this.props
        // reportStore.saveFilter(filterKey, RuleGrou   p.clone(this.state.ruleGroup))
        onSave(filterKey, RuleGroup.clone(this.state.ruleGroup))
    }

    discard = () => {
        const { ruleGroup } = this.state
        ruleGroup.discard()
    }

    questionOptions = (options) => {
        const { reportStore, filterKey } = this.props
        const { ruleGroup } = this.state
        return options.map((option, i) => (
            <QuestionOption ruleGroup={ruleGroup} option={option} index={i} addRuleOption={this.addRule} reportStore={reportStore} filterKey={filterKey} />
        ))
    }

    getDateRange = (id) => {
        const { ruleGroup } = this.state
        let [minDate, maxDate] = [undefined, undefined]
        if (id === 'startDate') {
            const adjacentRule = ruleGroup.findRule('endDate')
            const endDate = R.pathOr(undefined, ['options', 0, 'label'], adjacentRule)
            maxDate = endDate ? moment(endDate, 'DD/MM/YYYY') : undefined
        } else if (id === 'endDate') {
            const adjacentRule = ruleGroup.findRule('startDate')
            const startDate = R.pathOr(undefined, ['options', 0, 'label'], adjacentRule)
            minDate = startDate ? moment(startDate, 'DD/MM/YYYY') : undefined
        }
        return [minDate, maxDate]
    }

    dateOptions = (options) => {
        const { ruleGroup } = this.state
        return options.map((option, i) => {
            const { id, label } = option.pageQuestions[0].options[0]
            const existingRule = ruleGroup.findRule(id)
            const existingDate = R.pathOr(null, ['options', 0, 'label'], existingRule)
            const defaultDate = existingDate
                ? moment(existingDate, 'DD/MM/YYYY')
                : null
            const [minDate, maxDate] = this.getDateRange(id)
            return (
                <div
                    key={id}
                    className="report-filter"
                >
                    <span
                        style={{
                            fontWeight: 600,
                        }}
                    >
                        {label}
                    </span>
                    <Date
                        value={defaultDate}
                        onBlur={({ textFormat }) => {
                            this.addRule(label, id, { id, label: textFormat }, 'DT')
                        }}
                        placeholder={i18n.t('form.date.placeholder')}
                        allowManualDateEdit
                        maxDate={maxDate ? moment(maxDate) : undefined}
                        minDate={minDate ? moment(minDate) : undefined}
                    />
                </div>
            )
        })
    }

    renderLogic = (logicRule) => (
        <Select
            label="Function"
            defaultValue={logicRule.logic}
            options={RuleLogic.options}
            onBlur={({ value }) => { logicRule.logic = value }}
        />
    )

    renderRule = (rule) => {
        const { ruleGroup } = this.state
        return (
            <div>
                <Select
                    label="Page logic rule"
                    defaultValue={rule.logic}
                    options={Rule.getOptions(rule.questionTypeCode)}
                    onBlur={({ value }) => { rule.logic = value }}
                />
                <div style={{ color: '#8B99A7', marginTop: '25px', fontSize: '12px' }}>{rule.label}</div>
                <div>
                    {rule.options.map((option) => (
                        <div
                            key={option.id}
                            className="wrapper"
                            onClick={() => ruleGroup.removeRule(rule.id, option.id)}
                        >
                            <Badge
                                label={option.label}
                                isRounded
                                icon="fal fa-circle-xmark"
                            />
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    renderRules = () => {
        const { ruleGroup } = this.state
        const { rules } = ruleGroup

        return rules.map((rule) => {
            const { ruleType } = rule

            return (
                <div
                    className={`filter-${ruleType}`}
                    key={rule.id}
                >
                    {ruleType === 'logic' ? this.renderLogic(rule) : this.renderRule(rule)}
                </div>
            )
        })
    }

    filterOptions = () => {
        const { getFilterOptions } = this.props
        const { type, options } = getFilterOptions()

        switch (type) {
            case 'questions':
                return this.questionOptions(options)
            case 'date':
                return this.dateOptions(options)
            default:
                return null
        }
    }

    addRule = (label, id, rule, questionTypeCode) => {
        const { reportStore } = this.props
        const { ruleGroup } = this.state

        reportStore.addFilterRule(ruleGroup, label, id, rule, questionTypeCode)

        // const logic = ['CH', 'DT'].includes(questionTypeCode) ? 'AND' : 'OR'

        // ruleGroup.addRule(new Rule(
        //     {
        //         id,
        //         label,
        //         options: [rule],
        //         logic,
        //         questionTypeCode,
        //     },
        // ), questionTypeCode === 'DT')
    }

    hasRules = () => {
        const { ruleGroup, filterKey } = this.props
        const { rules } = ruleGroup[filterKey]
        return rules.length > 0
    }

    renderButton = () => {
        const { showBody } = this.state
        const hasRules = this.hasRules()

        const icon = showBody ? 'fa-light fa-chevron-up' : 'fa-light fa-chevron-down'
        const cssClass = hasRules ? 'secondary' : 'primary'
        const label = hasRules ? i18n.t('report.filter.edit') : i18n.t('report.filter.add')

        return (
            <Button
                cssClass={`regular ${cssClass}`}
                label={label}
                onClick={() => this.setState({ showBody: !showBody })}
                icon={icon}
            />
        )
    }

    addOpenEnded = (label, id, rule, questionTypeCode) => {
        const { reportStore } = this.props
        const { ruleGroup } = this.state

        console.log('addOpenEnded', id, rule.id)

        reportStore.addFilterRule(ruleGroup, label, id, rule, questionTypeCode)

        console.log(ruleGroup)
    }

    renderOpenEnded = () => {
        const { getFilterOptions, reportStore, filterKey } = this.props
        const { ruleGroup } = this.state
        const { options } = getFilterOptions()
        return (
            <div style={{
                display: 'flex', gap: '10px', flexDirection: 'column', flex: 1,
            }}
            >
                {options
                    .filter(({ pageQuestions }) => pageQuestions.length)
                    .map((option, i) => (
                        <QuestionOption showFilter ruleGroup={ruleGroup} option={option} index={i} addRuleOption={this.addOpenEnded} reportStore={reportStore} filterKey={filterKey} />
                    ))}
            </div>
        )
    }

    render() {
        const { showBody } = this.state
        const {
            title,
            description,
            optionTitle,
            optionDescription,
            filterTitle,
            filterDescription,
            filterKey,
        } = this.props

        return (
            <Panel cssClass="filter-panel">
                <PanelHeader noDivider>
                    <Applied show={this.hasRules()} />
                    <h4>{title}</h4>
                    <div style={{
                        display: 'flex', alignItems: 'center', flex: 2, justifyContent: 'space-between',
                    }}
                    >
                        <div style={{ flex: 1 }}>
                            {description}
                        </div>
                        {this.renderButton()}
                    </div>
                </PanelHeader>
                {showBody && (
                    <div className="body">
                        <div style={{ display: 'flex', gap: '10px' }}>
                            {filterKey === 'openEnded' && (
                                <div style={{
                                    display: 'flex', gap: '10px', flexDirection: 'column', flex: 1,
                                }}
                                >
                                    {this.renderOpenEnded()}
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Button
                                            label={i18n.t('discard')}
                                            icon="fa-thin fa-circle-xmark"
                                            cssClass="regular tertiary"
                                            onClick={this.discard}
                                        />
                                        <Button
                                            label={i18n.t('save')}
                                            icon="fa-thin fa-save"
                                            cssClass="regular primary"
                                            onClick={this.save}
                                        />
                                    </div>
                                </div>
                            )}
                            {filterKey !== 'openEnded' && (
                                <>
                                    <Panel style={{ display: 'flex', flex: 2 }}>
                                        <div style={{
                                            display: 'flex', gap: '10px', flex: 2, flexDirection: 'column', minHeight: 0,
                                        }}
                                        >
                                            <h5>{optionTitle}</h5>
                                            <InfoAccordion
                                                title={optionDescription}
                                                hideChevron
                                                cssClass="tertiary"
                                                icon="fa-light fa-circle-exclamation"
                                            />
                                            <div style={{
                                                display: 'flex', flexDirection: 'column', gap: '10px', minHeight: 0, overflow: 'auto',
                                            }}
                                            >
                                                {this.filterOptions()}
                                            </div>
                                        </div>
                                    </Panel>
                                    <Panel style={{
                                        display: 'flex', flexDirection: 'column', gap: '10px', flex: 3,
                                    }}
                                    >
                                        <div style={{
                                            display: 'flex', gap: '10px', flex: 2, flexDirection: 'column', minHeight: 0,
                                        }}
                                        >
                                            <h5>{filterTitle}</h5>
                                            <InfoAccordion
                                                title={filterDescription}
                                                hideChevron
                                                cssClass="tertiary"
                                                icon="fa-light fa-circle-exclamation"
                                            />
                                            <div style={{
                                                display: 'flex', flexDirection: 'column', border: '1px solid #F7F8FA', borderRadius: '6px', minHeight: 0, overflow: 'auto',
                                            }}
                                            >
                                                {this.renderRules()}
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Button
                                                label={i18n.t('discard')}
                                                icon="fa-thin fa-circle-xmark"
                                                cssClass="regular tertiary"
                                                onClick={this.discard}
                                            />
                                            <Button
                                                label={i18n.t('save')}
                                                icon="fa-thin fa-save"
                                                cssClass="regular primary"
                                                onClick={this.save}
                                            />
                                        </div>
                                    </Panel>
                                </>
                            )}
                        </div>
                    </div>
                )}
            </Panel>
        )
    }
}

export default FilterPanel
